const fileRequirementsElement =
  '<span class="zola-text file-info">Images ({fileTypes}) must be at least<br>{minWidth} x {minHeight} pixels and under {maxSize}MB each.</span>';

const faqLinkElement =
  '<div class="zola-text faq-link">Having trouble uploading photos? Check out our <a href="https://help.zola.com/hc/en-us/articles/360052051352-How-do-I-upload-photos-to-my-paper-products-" target="_blank">FAQs</a> or reach out at <a href="mailto:support@zola.com" target="_blank">support@zola.com</a></div>';

const DEFAULT_COPY = {
  uploading: `Hang tight! We're uploading your photos...`,
  errors: {
    dimensions: 'Images must be at least {minWidth}px wide and {minHeight}px high.',
    size: 'Images must be under {maxSize}MB',
    image: 'Images must be {fileTypes} files',
  },
  dialog: {
    tabs: {
      file: {
        drag: 'Drag & drop here',
        or: 'or',
        button: `Upload Your Files${fileRequirementsElement}`,
      },
      names: {
        file: 'Your Files',
      },
      preview: {
        done: 'Save',
        error: {
          dimensions: {
            title: 'Looks like your photo is too small...',
            text: `Images must be at least {minWidth}px wide and {minHeight}px high.${faqLinkElement}`,
            back: 'Select Another Photo',
          },
          size: {
            title: 'Looks like your photo is too big...',
            text: `Images must be under {maxSize}MB${faqLinkElement}`,
            back: 'Select Another Photo',
          },
          image: {
            title: 'Your selected file type cannot be uploaded…',
            text: `Images must be {fileTypes} files${faqLinkElement}`,
            back: 'Select Another Photo',
          },
        },
        image: {
          title: 'Edit Photo',
        },
        unknown: {
          title: `Hang tight! We're uploading your photos...`,
        },
        multiple: {
          tooManyFiles: 'What beautiful photos! Please upload no more than %max% at a time.',
        },
      },
    },
  },
};

export default DEFAULT_COPY;



// WEBPACK FOOTER //
// ./src/components/common/UploadcareWidget/widgetCopy.js